import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBHB60TLGEzA6SzGLaCICxfB9mRQsobc78",
  authDomain: "adulting-monster.firebaseapp.com",
  projectId: "adulting-monster",
  storageBucket: "adulting-monster.firebasestorage.app",
  messagingSenderId: "360948276078",
  appId: "1:360948276078:web:07ecb08d43a0bc33cb7f7f"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
